export default __webpack_public_path__ + "static/media/techsupport.9fe42610.jpg";